import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M12.96 8.478a.75.75 0 0 1 1.06-.006l2.268 2.24a.75.75 0 0 1 .001 1.065l-2.267 2.254a.75.75 0 0 1-1.057-1.064l.963-.958H10.48a1.49 1.49 0 0 0-1.49 1.49v.706a.75.75 0 0 1-1.5 0v-.706a2.99 2.99 0 0 1 2.99-2.99h3.469l-.982-.97a.75.75 0 0 1-.006-1.06" />
    <path
      fillRule="evenodd"
      d="M1.13 10.94a1.5 1.5 0 0 0 0 2.12l9.814 9.815a1.5 1.5 0 0 0 2.122 0l9.81-9.811a1.5 1.5 0 0 0 0-2.121l-9.814-9.815a1.5 1.5 0 0 0-2.12 0zM2.19 12l9.812-9.811 9.814 9.814-9.81 9.811z"
      clipRule="evenodd"
    />
  </>
);

const Directions = Icon('directions', svgContents);

export default Directions;
